import {gsap} from 'gsap';
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

gsap.config({
   nullTargetWarn: false,
});


// Headers
const headerElements = gsap.utils.toArray('.section-header .container .row');

headerElements.forEach((element, index) => {
    gsap.to(element, {
        y: 0,
        opacity: 1,
        duration: 1,
        delay: index * 0.5,
    })

});


// Intro titles
const introTitles = gsap.utils.toArray('.field--name-field-intro-title');

introTitles.forEach((introTitle, index) => {
    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: introTitle,
            start: 'top bottom',
        }
    });

    tl.to(introTitle, {x: 0, delay: 0.2, duration: 1});
    tl.to(introTitle, {color: 'white'});
});


// Text with image paragraph
const textWithImageParagraphs = gsap.utils.toArray('.layout-text-with-image-paragraph, .layout-price-files-paragraph');

textWithImageParagraphs.forEach(paragraph => {
    gsap.to(paragraph.querySelector('.image-wrapper'), {
        scrollTrigger: {
            trigger: paragraph,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1,
        },
        y: -100
    });
});


// Section text with image paragraph
const sectionTextWithImageParagraphs = gsap.utils.toArray('.layout-section-text-with-image-paragraph');

Array.from(sectionTextWithImageParagraphs).forEach(paragraph => {
    gsap.to(paragraph.querySelector('.image-wrapper'), {
        scrollTrigger: {
            trigger: paragraph,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1,
        },
        y: 50
    });
});


// Quote paragraph
const quoteParagraphs = gsap.utils.toArray('.layout-qoute-paragraph');

Array.from(quoteParagraphs).forEach(paragraph => {
    gsap.to(paragraph.querySelector('.field--name-field-quote-background-image img'), {
        scrollTrigger: {
            trigger: paragraph,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1,
        },
        scale: 1.05
    });
});


// Highlighted block
gsap.to('.intro-highlighted-block', {
    scrollTrigger: {
        trigger: '.intro-highlighted-block',
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1,
    },
    y: -50
});


// History paragraph
const historyItems = gsap.utils.toArray('.paragraph--type-history-item');

Array.from(historyItems).forEach((historyItem, index) => {

    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: historyItem,
            start: '-5% 90%',
            end: 'top center',
            scrub: 1,
            once: true,
        }
    });

    tl.to(historyItem.querySelector('.field--name-field-history-title'), {opacity: 1, delay: 1, duration: 5});
    tl.to(historyItem.querySelector('.field--name-field-history-date'), {opacity: 1, x: 0, delay: 1, duration: 10});
    tl.to(historyItem.querySelector('.time-line-item-text'), {opacity: 1, delay: 1, duration: 10});
});

gsap.to('.node--type-history-page .field--name-field-content .history-items-wrapper .timeline', {
   scrollTrigger: {
       trigger: '.node--type-history-page .field--name-field-content .history-items-wrapper',
       start: '20% bottom',
       end: 'bottom 30%',
       scrub: 1,
       once: true,
   },
    height: '100%'
});


// Our brand values
const ourBrandValuesParagraphs = gsap.utils.toArray('.paragraph--type-our-brand-values');

ourBrandValuesParagraphs.forEach(paragraph => {

    // Intro title
    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: paragraph,
            start: 'top bottom',
        }
    });

    tl.to('.intro-title', {x: 0, delay: 0.2, duration: 1});
    tl.to('.intro-title h2', {color: 'white'});
    tl.to('.intro-title .dot:first-of-type', {opacity: 1, x: 0});
    tl.to('.intro-title .dot:nth-of-type(2)', {opacity: 1, x: 0});


    // Brand value
    const ourBrandValueParagraphs = gsap.utils.toArray(paragraph.querySelectorAll('.field--name-field-brand-values > .field__item'));

    ourBrandValueParagraphs.forEach((brandValue, index) => {
        gsap.from(brandValue, {
            scrollTrigger: {
                trigger: brandValue,
                start: 'top 70%',
                end: 'bottom bottom',
            },
            opacity: 0,
            y: index * 40,
            delay: index * 0.3,
        });
    });
});


